module.exports = __webpack_public_path__ + "static/media/MSBadges2.867a47df.jpg";